define('components/course/models/slide-type/interactive-container',[
    "components/course/models/slide-type/zeus-base"
], function(BaseModel) {
    "use strict";

    return BaseModel.extend({
        "defaults": function() {
            var baseDefaults = BaseModel.prototype.defaults.call(this),
                defaults = {
                    "data": {
                        "showNavigationButtons": true,
                        "useAnimation": false,
                        "interactiveGUID": '',
                        "animationProperties": null,
                        "saveState": {
                            "interactiveState": null
                        }
                    }
                };
            return _.extend(baseDefaults, defaults);
        },

        "initialize": function() {
            this._populateData();
        },

        "_populateData": function() {
            var data = this.get('data');

            if (!data) {
                this.set(this.defaults());
            }
            if (data && !data.saveState) {
                data.saveState = {
                    "interactiveState": null
                };
            }
        },

        "authoringJSONKey": function() {
            return _.extend(BaseModel.prototype.authoringJSONKey.call(this), {
                "data": {
                    "showNavigationButtons": null,
                    "useAnimation": null,
                    "interactiveGUID": null,
                    "animationProperties": null,
                    "globalComponentData": null
                }
            });
        }
    });
});

